import React from 'react';
import { Title, Description } from '../../components/layouts';
import './style.scss';
import { getTrack } from '../../helpers';

const track = getTrack({ block: 17 });

export function CPUBrief({ mobile = false }) {

  return (
    <div className="page-section section-cpu-brief inverted" data-track={track}>
      <div className="section-content title center">
        <Title>
          全面革“芯”
          <br/>
          从未如此强大
        </Title>
        {/*<Description>*/}
        {/*  对性能的执著，从未止息！X60 Pro+ 携高通骁龙888处理器、12GB运存<sup>4</sup>、内存融合*/}
        {/*  <br/>*/}
        {/*  技术，以迅猛之姿，强势来袭。*/}
        {/*</Description>*/}
      </div>
    </div>
  );
}
